import { Reveal, SectionHeading } from "@/components/Reveal";
import { HOW_IT_WORKS } from "@/lib/constants";

export default function HowItWorksSection() {
  return (
    <section className="border-y border-white/10 bg-ink-900 py-14 sm:py-28" data-testid="how-it-works-section">
      <div className="container-brox">
        <SectionHeading eyebrow="CUM FUNCȚIONEAZĂ" title={<>Cinci pași.<br />Zero bătăi de cap.</>} />

        <div className="relative mt-10">
          <div className="absolute left-0 right-0 top-7 hidden border-t border-dashed border-white/15 lg:block" aria-hidden="true" />
          <ol className="grid gap-7 sm:grid-cols-2 lg:grid-cols-5 lg:gap-5">
            {HOW_IT_WORKS.map((step, i) => (
              <Reveal key={step.nr} delay={0.08 * i} className="relative">
                <li className="flex flex-col gap-4 lg:block">
                  <span className="relative z-10 inline-flex h-14 w-14 items-center justify-center border border-copper/50 bg-ink-950 font-mono text-sm font-semibold text-copper">
                    {step.nr}
                  </span>
                  <div>
                    <h3 className="display-title text-xl text-paper sm:text-2xl">{step.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{step.text}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
